import classNames from 'classnames';
import { Button, Heading } from 'yoso';
import { T } from '~/components/I18n';
import jumbotronStyles from '~/components/Jumbotron/Jumbotron.module.scss';
import { useTwitterUrl } from '~/components/Url/Url.hooks';
import styles from './CommunityCta.module.scss';
import astronaut from './astronautWithDog.png';

export type CommunityCtaProps = {
  className?: string;
};
export const CommunityCta = ({ className }: CommunityCtaProps) => {
  const twitterUrl = useTwitterUrl();
  return (
    <div className={classNames(jumbotronStyles.root, styles.root, className)}>
      <img
        className={classNames(jumbotronStyles.image, styles.image)}
        src={astronaut}
        alt="astronaut"
        width={375}
        height={295}
      />
      <Heading level={4} className={jumbotronStyles.title}>
        <T name="citizen_home_community_title" />
      </Heading>
      <p className={classNames(jumbotronStyles.description, styles.description)}>
        <T name="citizen_home_community_desc" />
      </p>
      <div className={jumbotronStyles.footer}>
        <Button
          as="a"
          href="https://discord.gg/SCkEdqTJG7"
          target="_blank"
          className={classNames(jumbotronStyles.button, styles.leftButton)}
          data-event="click"
          data-event-target="community_btn_in_home"
          data-event-sns_name="Discord">
          <T name="citizen_button_title_discord" />
        </Button>
        <Button
          as="a"
          href={twitterUrl}
          target="_blank"
          className={classNames(jumbotronStyles.button, styles.rightButton)}
          data-event="click"
          data-event-target="community_btn_in_home"
          data-event-sns_name="Twitter">
          <T name="citizen_button_title_x" />
        </Button>
      </div>
    </div>
  );
};
